import { emptySplitApi } from './index'

export const searchEngineApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getAvailableUsIndexes: builder.query({
            query: () => ({
                url: `api/v1/search-engine-service/elastic-search/indexes/us`,
                method: "GET",
            }),
        }),
        getFoundationsByIndex: builder.mutation({
            query: ({ indexName, profileIdList }) => ({
                url: `api/v1/search-engine-service/elastic-search/foundations-by-index`,
                method: "POST",
                body: { indexName, profileIdList }
            }),
        }),
        searchBySearchType: builder.mutation({
            query: ({ searchType, ...model }) => ({
                url: `api/v1/search-engine-service/search/${searchType}`,
                method: "POST",
                body: model
            }),
        }),
        searchByGivingHistory: builder.mutation({
            query: ({ searchType, ...model }) => ({
                url: `api/v1/search-engine-service/search/by-giving-history`,
                method: "POST",
                body: model
            }),
        }),
        searchByGivingHistoryV2: builder.mutation({
            query: ({ searchType, ...model }) => ({
                url: `api/v2/search-engine-service/search/by-giving-history`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByGivingHistory"}],
        }),
        getGrantDetails: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/grant-details/${model.profileId}`,
                method: "POST",
                body: model
            }),
        }),
        getGrantDetailsV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/grant-details/${model.profileId}`,
                method: "POST",
                body: model
            }),
        }),
        crossRefGrantDetails: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/cross-ref-grant-details/${model.profileId}`,
                method: "POST",
                body: model
            }),
        }),
        searchByName: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-name`,
                method: "POST",
                body: model
            }),
        }),
        searchByNameV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/by-name`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByName" }],
        }),
        searchByDirector: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-director`,
                method: "POST",
                body: model
            }),
        }),
        searchByDirectorV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/by-director`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByDirector"}],
        }),
        searchByYear: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-year`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByYear"}],
        }),
        searchByRating: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-rating`,
                method: "POST",
                body: model
            }),
        }),
        searchByCustom: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-custom`,
                method: "POST",
                body: model
            }),
        }),
        searchByCustomV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/by-custom`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByCustom" }],
        }),
        searchByKeyword: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-keywords`,
                method: "POST",
                body: model
            }),
        }),
        searchByKeywordV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/by-keywords`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByKeyword"}],
        }),
        getCountries: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/country`,
                method: "GET",
            }),
        }),
        getCountries2: builder.query({
            query: (model) => ({
                url: `api/v1/search-engine-service/country`,
                method: "GET",
            }),
            transformResponse: (response) => response.map(item => ({
                id: item.key,
                label: item.label,
                value: item.key,
            })),
        }),
        getInternacionalCountries: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/country/internacional`,
                method: "GET",
            }),
        }),
        getInternacionalCountries2: builder.query({
            query: (model) => ({
                url: `api/v1/search-engine-service/country/internacional`,
                method: "GET",
            }),
            transformResponse: (response) => response.map(item => ({
                id: item.key,
                value: item.value,
                label: item.label,
                amount: item.amount,
            }))
        }),
        getCounties: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/country/counties`,
                method: "POST",
                body: model
            }),
        }),
        getCounties2: builder.query({
            query: (model) => ({
                url: `api/v1/search-engine-service/country/counties`,
                method: "POST",
                body: model
            }),
            transformResponse: (response) => response.map(item => ({
                id: item.key,
                label: item.label,
                value: item.key,
                secondaryAction: item.provinceOrStateCode,
            }))
        }),
        getCitiesByCounties: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/country/cities-by-counties`,
                method: "POST",
                body: model
            }),
        }),
        searchByInternacionalFunding: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/by-internacional-funding`,
                method: "POST",
                body: model
            }),
        }),
        searchByInternacionalFundingV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/by-internacional-funding`,
                method: "POST",
                body: model
            }),
            invalidatesTags: () => [{type: "SavedHistory", id: "ByInternacionalFunding"}],
        }),
        getEnhancedWordsV2: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/enhancement-words`,
                method: "POST",
                body: model
            }),
        }),
        getEnhancedWords: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/enhancement-words-2`,
                method: "POST",
                body: model
            }),
        }),
        searchDeadlines: builder.mutation({
            query: (model) => ({
                url: `api/v2/search-engine-service/search/deadlines`,
                method: "POST",
                body: model
            }),
        }),
        getFoundationApplicationByProfileId: builder.mutation({
            query: (profileId) => ({
                url: `api/v2/search-engine-service/search/application-foundation/${profileId}`,
                method: "GET",
            }),
        }),
        getSearchSummary: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/search-summary/${model.pageType}`,
                method: "POST",
                body: model
            }),
        }),
        findPerfectMatchList: builder.mutation({
            query: (profileIdList) => ({
                url: `api/v1/search-engine-service/search/perfect-match`,
                method: "POST",
                body: [...profileIdList]
            }),
        }),
        searchTargetBeneficiaries: builder.mutation({
            query: () => ({
                url: `api/v1/search-engine-service/search/target-beneficiaries`,
                method: "POST"
            }),
        }),
        generateStatisticalProof: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/statistical-proof`,
                method: "POST",
                body: model
            }),
        }),
        findSimilarCharities: builder.mutation({
            query: (model) => ({
                url: `api/v1/search-engine-service/search/similar-charities?` +
                     `pageNumber=${model?.pageNumber ?? 0}&pageSize=${model?.pageSize ?? 20}` +
                     `&searchTerm=${encodeURIComponent(model?.searchTerm ?? "")}` +
                     (model?.states ?? []).map((state) => `&states=${encodeURIComponent(state)}`).join("") +
                     (model?.counties ?? []).map((county) => `&counties=${encodeURIComponent(county)}`).join("") +
                     (model?.cities ?? []).map((city) => `&cities=${encodeURIComponent(city)}`).join(""),
                method: "GET",
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useSearchBySearchTypeMutation,
    useSearchByGivingHistoryMutation,
    useSearchByGivingHistoryV2Mutation,
    useGetGrantDetailsMutation,
    useGetGrantDetailsV2Mutation,
    useSearchByNameMutation,
    useSearchByDirectorMutation,
    useSearchByYearMutation,
    useSearchByRatingMutation,
    useSearchByCustomMutation,
    useSearchByCustomV2Mutation,
    useSearchByKeywordMutation,
    useGetCountriesMutation,
    useGetCountries2Query,
    useGetCountiesMutation,
    useGetCounties2Query,
    useGetCitiesByCountiesMutation,
    useGetInternacionalCountriesMutation,
    useSearchByInternacionalFundingMutation,
    useSearchByInternacionalFundingV2Mutation,
    useGetEnhancedWordsV2Mutation,
    useSearchByNameV2Mutation,
    useSearchByDirectorV2Mutation,
    useSearchByKeywordV2Mutation,
    useSearchDeadlinesMutation,
    useGetEnhancedWordsMutation,
    useCrossRefGrantDetailsMutation,
    useGetFoundationApplicationByProfileIdMutation,
    useGetSearchSummaryMutation,
    useGetInternacionalCountries2Query,
    useFindPerfectMatchListMutation,
    useSearchTargetBeneficiariesMutation,
    useGenerateStatisticalProofMutation,
    useFindSimilarCharitiesMutation,
    useGetAvailableUsIndexesQuery,
    useGetFoundationsByIndexMutation
} = searchEngineApi;
